import {useState} from "react";
import {Button, Container} from "react-bootstrap";
import {Link} from "react-router";
import {common, rich} from "../i18n";

// Says what the site stores in the browser (all of it essential or a visitor's own choice, so no consent is asked
// for) until the visitor dismisses it. The dismissal is remembered here; see pages/CookiesPage.tsx. At the top of the
// page, in the flow, rather than fixed over the content, where it could hide whatever has keyboard focus.
const STORAGE_KEY = 'tsa-cookie-notice';

function dismissed(): boolean {
    try {
        return localStorage.getItem(STORAGE_KEY) === '1';
    } catch {
        return false;
    }
}

export function CookieNotice() {
    const [open, setOpen] = useState(() => !dismissed());

    if (!open) {
        return null;
    }

    const dismiss = () => {
        try {
            localStorage.setItem(STORAGE_KEY, '1');
        } catch {
            // Not remembered: hidden for this page only.
        }
        setOpen(false);
        // The button is gone: keyboard focus continues at the page rather than back at the top of the document.
        document.getElementById('main-content')?.focus();
    };

    return (
        <div className="bg-body-tertiary border-bottom py-2" role="region" aria-label={common.cookieNotice.label}>
            <Container className="d-flex flex-wrap align-items-center justify-content-between gap-2">
                <span className="small">
                    {rich(common.cookieNotice.text, { link: text => <Link to="/cookies">{text}</Link> })}
                </span>
                <Button size="sm" onClick={dismiss}>{common.cookieNotice.dismiss}</Button>
            </Container>
        </div>
    );
}
